import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Divider, Button, Modal, Backdrop, Slide, Card, CircularProgress } from '@material-ui/core';
import SearchDeal from 'components/SearchDeal';
import PersonInfo from 'components/PersonInfo';
import '../../css/inputs.css';
import '../../css/button.css';
import { makeStyles } from '@material-ui/core/styles';
import { Fields1, Fields2, Fields3 } from 'components/edit-section-selects/index';
import ProgressBar from 'components/ProgressBar';
import { PIPEDRIVE_API, getOptionsIdToLabel } from 'api/pipedrive';
import ACTIONS from 'redux-lib/actions/actions';
import Quotes from 'components/Quotes';
import GRAPHQL_API from 'api/graphql';
import { Save, Send } from '@material-ui/icons';
import _, { isArray } from 'lodash';
import SaveDataContent from 'components/edit-section-selects/SaveDataContent';
import SendOffersContent from 'components/edit-section-selects/SendOffersContent';
import Toaster from 'components/Toaster';
import { mapSendgridData, mapDealDealData, hasValidEmails } from 'utils/utils';
import SENDGRID_API from 'api/sendgrid';
import Legends from 'components/Legend';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '& .MuiTextField-root': {
      width: '100%',
    },
  },
  control: {
    padding: theme.spacing(2),
  },
  divider: {
    margin: '37px 20px'
  },
  marginLargeTop: {
    marginTop: 50
  },
  quoteContainer: {
    marginTop: 20, 
    padding: '0 27px'
  },
  saveIcon: {
    margin: theme.spacing(1),
  },
  sendIcon: {
    margin: theme.spacing(1),
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 0,
    maxWidth: 700,
    margin: 'auto'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 0
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function Main(props) {
  const classes = useStyles();
  const [ saveModalOpen, setSaveModalOpen ] = useState(false);
  const [ sendModalOpen, setSendModalOpen ] = useState(false);
  const [ openToaster, setOpenToaster ] = useState(false);
  const [ openBackrop, setOpenBackdrop ] = useState(false);
  const [ toasterSeverity, setToasterSeverity ] = useState(null);
  const [ toasterMsg, setToasterMsg ] = useState(null);
  const [ disableSave, setDisableSave ] = useState(true);
  const dispatch = useDispatch();
  const states = useSelector(state => {
    return state.globalStates
  })

  const getOptions = useCallback( (cancelled) => {
    getVehiclTypes(cancelled)
    getBanks(cancelled)
    getAONOptions(cancelled)
    getBankPartners(cancelled)
  }, [] )

  useEffect(() => {
    let cancelled = false;
    getOptions(cancelled)
    return () => {
      cancelled = true;
    }
  }, [getOptions])

  useEffect(() => {
    isNotValidForSaving();
  }, [
    states.car_id,
    states.body_type,
    states.deal_id,
    states.pa,
    states.car_type,
    states.fmv,
    states.vehicle_type
  ])

  const getVehiclTypes = (cancelled) => {
    PIPEDRIVE_API.getDealField( process.env.REACT_APP_PD_CI_VEHICLE_TYPE_FIELD_ID ).then(data => {
      if( cancelled ) return;
      if( data.success && data.data ) {
        if( data.data.options ) {
            dispatch({
              type: ACTIONS.UPDATE_VEHICLE_TYPES,
              payload: getOptionsIdToLabel(data.data.options)
            })
        }
      }
    })
  }

  const getBanks = (cancelled) => {
    PIPEDRIVE_API.getDealField( process.env.REACT_APP_PD_CI_BANK_FIELD_ID ).then(data => {
      if( cancelled ) return;
      if( data.success && data.data ) {
        if( data.data.options ) {
            dispatch({
              type: ACTIONS.UPDATE_BANKS,
              payload: getOptionsIdToLabel(data.data.options)
            })
        }
      }
    })
  }

  const getAONOptions = (cancelled) => {
    PIPEDRIVE_API.getDealField( process.env.REACT_APP_PD_CI_AON_FIELD_ID ).then(data => {
      if( cancelled ) return;
      if( data.success && data.data ) {
        if( data.data.options ) {
            dispatch({
              type: ACTIONS.UPDATE_AON_OPTIONS,
              payload: getOptionsIdToLabel(data.data.options)
            })
        }
      }
    })
  }

  const getBankPartners = (cancelled) => {
    GRAPHQL_API.getBankPartners().then((data) => {
      if( cancelled ) return;
      if( data && data.data ) {
        if( data.data.get_car_insurance_bank_partners ) {
          const banksArr = data.data.get_car_insurance_bank_partners
          dispatch({
            type: ACTIONS.UPDATE_GRAPH_BANK_PARTNERS,
            payload: banksArr
          })
        }
      }
    })
  }


  const handleSaveModalOpen = () => {
    const areEmailsValid = hasValidEmails(states.person_emails);
    if( !areEmailsValid ) {
      alert(`There are invalid emails detected. Please try again.`);
      return;
    }
    setSaveModalOpen(true);
  };

  const handleSaveModalClose = () => {
    setSaveModalOpen(false);
  };

  const handleSendModalOpen = () => {
    
    const areEmailsValid = hasValidEmails(states.person_emails);
    if( !areEmailsValid ) {
      alert(`There are invalid emails detected. Please try again.`);
      return;
    }
    setSendModalOpen(true);
  };

  const handleSendModalClose = () => {
    setSendModalOpen(false);
  };

  const handleToasterClose = () => {
    setOpenToaster(false)
  }

  const handleSaveSubmit = () => {
    setOpenBackdrop(true)
    handleSaveModalClose()

    const dealData = mapDealDealData(states);

    if( !states.deal_id ) {
      setToasterSeverity('error')
      setToasterMsg('Deal ID is required')
      setTimeout(() => {
          setOpenToaster(true)
          setOpenBackdrop(false)
      }, 1000)
    } else if( !states.person_id ) {
      setToasterSeverity('error')
      setToasterMsg('Person ID is required')
      setTimeout(() => {
          setOpenToaster(true)
          setOpenBackdrop(false)
      }, 1000)
    } else {
      const requestData = { request: `update_deal`, data: dealData };
      PIPEDRIVE_API.updateDealData(requestData).then((data) => {
        if( data.success ) {
          setToasterSeverity('success')
          setToasterMsg(`${ data.data }`);
        } else {
          setToasterSeverity('error')
          setToasterMsg(`${ data.data }`);
        }
        setTimeout(() => {
          setOpenToaster(true)
          setOpenBackdrop(false)
        }, 1000)
      })
    }
    
  }

  const handleSendSubmit = () => {
    
    setOpenBackdrop(true)
    handleSendModalClose()

    const offers = mapSendgridData(states);

    if(!offers) {
      setToasterSeverity( `error` )
      setToasterMsg( `There are no quotes to send.` )
      setTimeout(() => {
          setOpenToaster(true)
          setOpenBackdrop(false)
      }, 1000)
    }

    const dealData = mapDealDealData(states);

    const requestData = { request: `update_deal`, data: dealData };
    if(!requestData.data.deal_id || !requestData.data.person_id) {
      setToasterSeverity( 'error' )
      setToasterMsg( 'No deal associated to this offer. Make sure there is an existing Pipedrive deal and person linked to the email.' )
      setTimeout(() => {
          setOpenToaster(true)
          setOpenBackdrop(false)
      }, 1000)
    } else {
      PIPEDRIVE_API.updateDealData(requestData).then((data) => {
        if( data.success ) {
          SENDGRID_API.sendOffers( offers ).then((res) => {
            setToasterSeverity( res.data.status ? 'success' : 'error' )
            setToasterMsg( res.data.message )
            setTimeout(() => {
                setOpenToaster(true)
                setOpenBackdrop(false)
            }, 1000)
          })
        } else {
          setToasterSeverity('error')
          setToasterMsg(`${ 'There was an error saving data in CRM' }`);
          setTimeout(() => {
            setOpenToaster(true)
            setOpenBackdrop(false)
          }, 1000)
        }
      })
    }
  }

  const isNotValidForSending = () => {
    let res = false;
    if( !states.person_emails || !states.selected_quotes ) {
      return true
    }
    if( isArray( states.person_emails ) ) {
      if( states.person_emails.length === 0 ) {
        res = true
      }
    }
    if( isArray( states.selected_quotes ) ) {
      if( states.selected_quotes.length === 0 ) {
        res = true
      }
    }
    return res;
  }

  const isNotValidForSaving = () => {
    const check = [
      'car_brand',
      'car_model',
      'car_year',
      'car_trim',
      'car_id',
      'body_type',
      'aon',
      'deal_id',
      'pa',
      'car_type',
      'fmv',
      'vehicle_type'
    ];
    let res = [];
    check.forEach((state, index) => {
      if(!states[state] || states[state] === '') {
        res.push(state)
      }
    })
    setDisableSave(res.length > 0)
  }

  return(
    <div className={classes.root} id="fields-container">
      <ProgressBar/>
      <Grid container spacing={2} style={{ paddingTop: 30 }} className="fields-container-grid">
        <Grid item xs={4}>
          <SearchDeal/>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 20, position: 'relative' }} className="fields-container-grid">
        <Grid item xs={8}>
          <PersonInfo/>
        </Grid>
      </Grid>
      <Divider component="div" className={ classes.divider }/>
      <Grid container spacing={2} className="fields-container-grid">
        {Fields1.map((Item, key) => {
          return(
            <Grid key ={ `ops-ui-field-${ key }` } item xs={2}>
              <Item/>
            </Grid>
          )
        })}
      </Grid>
      <Grid container spacing={2} className="fields-container-grid">
        {Fields2.map((Item, key) => {
          return(
            <Grid key ={ `ops-ui-field-${ key }` } item xs={2}>
              <Item/>
            </Grid>
          )
        })}
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 20 }} className="fields-container-grid">
        {Fields3.map((Item, key) => {
          return(
            <Grid key ={ `ops-ui-field-${ key }` } item xs={2}>
              <Item/>
            </Grid>
          )
        })}
      </Grid>

      <Grid container spacing={2} style={{ marginTop: 20, width: '85%', textAlign: 'right' }} className="fields-container-grid">
        <Grid item xs={12}>
        <Button
          variant="contained"
          disabled={ disableSave }
          color={ disableSave ? 'default' : 'primary' }
          size="large"
          className={ `${ classes.saveIcon } ${ disableSave ? '' : 'btn-primary' }` }
          startIcon={<Save />}
          onClick={ handleSaveModalOpen } 
        >
          Save
        </Button>
        <Button
          variant="contained"
          disabled={ isNotValidForSending() }
          color="primary"
          size="large"
          className={ `${ classes.sendIcon } ${ isNotValidForSending() ? '' : 'btn-success' }` }
          // className={ `${ classes.saveIcon } ${ states.deal_id ? 'btn-primary' : '' }` }
          startIcon={<Send />}
          onClick={ handleSendModalOpen } 
        >
          Send Offers
        </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2} className={ classes.quoteContainer }>
        <Grid item xs={12} style={{"min-height": "300px", background: '#ffffff'}}>
          <Legends/>
          <Quotes/>
        </Grid>
      </Grid>

      <Modal
        aria-labelledby="transition-save-modal-title"
        aria-describedby="transition-save-modal-description"
        className={classes.modal}
        open={saveModalOpen}
        onClose={handleSaveModalClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide direction="up" in={saveModalOpen} mountOnEnter unmountOnExit>
          <Card elevation={4} className={classes.paper}>
            <SaveDataContent handleModalClose={ handleSaveModalClose } handleSubmit={ handleSaveSubmit }/>
          </Card>
        </Slide>
      </Modal>

      <Modal
        aria-labelledby="transition-send-modal-title"
        aria-describedby="transition-send-modal-description"
        className={classes.modal}
        open={sendModalOpen}
        onClose={handleSendModalClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide direction="up" in={sendModalOpen} mountOnEnter unmountOnExit>
          <Card elevation={4} className={classes.paper}>
            <SendOffersContent handleModalClose={ handleSendModalClose } handleSubmit={ handleSendSubmit }/>
          </Card>
        </Slide>
      </Modal>

      <Toaster open={ openToaster } onClose={ handleToasterClose } message={ toasterMsg } severity={ toasterSeverity }/>
      <Backdrop className={classes.backdrop} open={openBackrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>

  )
}

export default React.memo(Main);